import React from 'react';
import PageBanner from '../components/PageBanner';
import AwardsCertificates from '../components/AwardsCertificates';

function AwardsPage() {
  return (
    <>
      <PageBanner title="Awards & Certificates" />
      <AwardsCertificates />
    </>
  );
}

export default AwardsPage;
